<template>
  <div class="h-full p-8 pt-0 w-full overflow-auto" ref="scroller">
    <UserProperty
      @dataAvailable="
        data => {
          userData = data || {}
        }
      "
    />
    <DataGetter
      @dataAvailable="
        data => {
          appInfo = data?.metaData || {}
        }
      "
      contentId="appInfo"
    />
    <DataGetter
      @dataAvailable="
        data => {
          platformAccessSubscription = data?.metaData || {}
        }
      "
      contentId="platformAccessSubscription"
    />

    <div class="py-8"></div>
    <div class="text-center font-bold text-4xl title-color">
      Sélectionner le plan Ekidiscount adapté à vos besoins
    </div>
    <div class="py-2"></div>

    <div class="text-center md:w-1/3 mx-auto">
      Utilisez Ekidiscount pour publier facilement vos produits, toucher plus de
      clients et booster vos ventes. Choisissez le plan qui correspond à vos
      objectifs et commencez à vendre dès aujourd’hui.
    </div>
    <!-- <div class="py-3"></div> -->
    <!-- <div class="flex justify-center">
      <div class="flex p-1 rounded-full bg-white text-lg">
        <button
          class="w-[6rem] md:w-[8rem] text-center p-2 rounded-full py-1 duration-300"
          v-for="(period, i) in periods"
          :key="i"
          :class="{ 'bg-primary text-white': period.id == selectedPeriod.id }"
          @click="selectedPeriod = period"
        >
          {{ period.name }}
        </button>
      </div>
    </div> -->

    <div class="flex flex-col md:flex-row justify-center py-12 gap-6">
      <div
        class="overflow-hidden relative rounded-[2rem] p-4 bg-white border w-full"
        v-for="(pricing, i) in pricings"
        :key="i"
      >
        <div
          v-if="i > 1"
          class="absolute w-full p-[100%] top-0 left-1/2 -translate-x-1/2"
          style="
            background: radial-gradient(
              at center -10rem,
              #e2d8f9,
              #f7eff8 50%,
              #fff
            );
          "
        ></div>
        <button
          v-if="platformAccessSubscription?.planName == pricing.title"
          class="top-0 w-[15rem] origin-top-center translate-y-2/3 translate-x-[20%] rotate-[35deg] bg-primary-500 right-0 absolute uppercase overflow-hidden text-white px-3 py-2"
        >
          <div class="relative font-bold">Offre actuelle</div>
        </button>
        <div class="flex flex-col h-full relative">
          <div class="py-1"></div>
          <div class="flex">
            <div
              class="text-2xl title-color rounded-3xl shadow px-4 py-2 inline-block font-bold"
              :class="{
                'text-white bg-primary': i <= 1,
                'bg-white title-color': i > 1,
              }"
            >
              {{ pricing.title }}
            </div>
          </div>
          <div class="py-2"></div>
          <div class="description-color text-lg">
            {{ pricing.description }}
          </div>
          <div class="py-2"></div>
          <div>
            <span class="text-5xl font-bold title-color">
              {{ pricing.amount }}
            </span>
            <span class="text-lg relative"> FCFA/mois </span>
          </div>
          <div class="py-4"></div>
          <div class="border-b"></div>
          <div class="py-3"></div>
          <div class="flex gap-4 flex-col">
            <div
              class="flex items-center gap-2 text-lg"
              v-for="(option, i) in pricing.options"
              :key="i"
            >
              <div class="w-8 h-8 min-w-8 rounded-full">
                <img
                  src="@/assets/images/all/close-red.svg"
                  alt=""
                  class="w-full h-full p-2.5 opacity-60"
                  v-if="!option.isIncluded"
                />
                <img
                  src="@/assets/images/all/check-normal.svg"
                  v-else
                  alt=""
                  class="w-full h-full"
                />
              </div>
              <div
                :class="{
                  'line-through opacity-50': !option.isIncluded,
                }"
              >
                <div class="text-base title-color font-bold">
                  {{ option.name }}
                </div>
              </div>
            </div>
          </div>
          <div class="py-4"></div>
          <div class="w-full mt-auto">
            <button
              v-if="platformAccessSubscription?.planName !== pricing.title"
              @click="launchPayment(pricing)"
              class="buttonComponent border-2 text-xl rounded-full w-full"
              :class="{
                'text-primary bg-primary-50': i <= 1,
              }"
            >
              {{
                platformAccessSubscription?.planName
                  ? 'Changer de plan'
                  : 'Activer'
              }}
            </button>
          </div>
          <div class="py-4"></div>
        </div>
      </div>
    </div>

    <EventListener
      :events="[
        'platform_access_subscription_payment_launched',
        'failed_to_launch_platform_access_subscription_payment',
        'transaction_url_available',
        'collection_finished_available',
        'iframe_closed',
      ]"
      @platform_access_subscription_payment_launched="onPaymentLaunched"
      @failed_to_launch_platform_access_subscription_payment="
        onPaymentFailedToLaunch
      "
      @transaction_url_available="onPaymentUrlAvailable"
      @collection_finished_available="onPaymentFinished"
      @iframe_closed="onIframeClosed"
    />
  </div>
</template>

<script>
import UserProperty from '@/components/user/UserProperty.vue'
import EventListener from '@/components/utils/EventListener.vue'
import DataGetter from '@/components/utils/DataGetter.vue'

export default {
  name: 'homeComponent',
  components: {
    UserProperty,
    EventListener,
    DataGetter,
  },
  data() {
    return {
      userData: {},
      subscription: {},
      kycData: {},
      eventsIds: [],
      appInfo: {},
      latestTransactionUrl: '',
      latestTransactionId: '',
      periods: [
        { duration: 1, name: '1 Mois', id: '1month' },
        { duration: 3, name: '3 Mois', id: '3months' },
        { duration: 6, name: '6 Mois', id: '6months' },
        { duration: 1, name: '1 Ans', id: '1year' },
      ],
      selectedPeriod: { duration: 3, name: '3 Mois', id: '3months' },
    }
  },
  beforeUnmount() {
    this.eventsIds.map(this.$Events.removeHandler)
  },
  mounted() {},
  methods: {
    async launchPayment(pricing, nbMonth) {
      if (this.platformAccessSubscription?.planName) {
        const confirm = await this.$Events.sendDataRequestResolve(
          'customPrompt',
          {
            title: `Annuler votre abonnement ${this.platformAccessSubscription?.planName} ?`,
            subTitle: `Voulez vous vraiment annuler votre abonnement ${this.platformAccessSubscription?.planName} pour activer l'abonnemenr ${pricing.title}? Nous ne vous rembourseront pas si vous continuer `,

            successText: `<span class="text-red-600">Annuer ${this.platformAccessSubscription?.planName} et changer de plan </span>`,
            cancelText: 'Retour',
          },
          9999999999,
        )
        if (!confirm.accepted) return
      }
      const prompt = await window.choicePrompt({
        title: 'Choissisez comment payer.',
        options: [
          {
            title: 'Payer par mobile money',
            id: 'mobileMoney',
          },
          {
            title: 'Payer par carte bancaire',
            id: 'card',
          },
        ],
        formatDisplay: data => data?.title || '',
        successText: 'Payer',
      })
      if (!prompt.accepted || !prompt.data) return null
      await new Promise(r => setTimeout(r, 500))
      this.$Events.dispatchEvent('start_loading')
      this.$Events.dispatchEvent(
        'platform_access_subscription_payment_required',
        {
          paymentMethod: prompt.data.id,
          duration: this.selectedPeriod.duration,
          planId: pricing.id,
          planName: pricing.title,
        },
      )
      this.listenLaunchedTransaction = true
    },
    onPaymentLaunched() {
      this.$Events.dispatchEvent('toast_notification', {
        title: 'Paiement lancé',
        body: 'La paiement a été lancé. Veuillez patienter et confirmer',
      })
    },
    onPaymentFailedToLaunch() {
      this.$Events.dispatchEvent('finish_loading')
      this.$Events.dispatchEvent('toast_notification', {
        title: 'Paiement non lancé',
        body: "Echec d'initiation du paiement, veuillez réessayer.",
      })
    },
    onPaymentUrlAvailable({ url, id }) {
      if (!this.listenLaunchedTransaction) return
      console.log(id)
      this.listenLaunchedTransaction = false
      this.latestTransactionUrl = url
      this.latestTransactionId = id
      this.$Events.dispatchEvent('url_opening_required', {
        url: url,
        useIframe: true,
        iframeClasses: 'w-full h-full',
      })
    },
    onPaymentFinished({ id, status }) {
      console.log(id, this.latestTransactionId)
      if (id == this.latestTransactionId) {
        this.$Events.dispatchEvent('close_iframe')
        this.$Events.dispatchEvent('access_subscription_payment_done')
        this.latestTransactionId = ''
        this.latestTransactionUrl = ''
        if (status == 'success') {
          this.$Events.dispatchEvent('toast_notification', {
            title: 'Paiement réussi',
            body: 'Votre abonnement a réussi',
          })
        } else {
          this.$Events.dispatchEvent('toast_notification', {
            title: 'Echec du paiement',
            body: "Le paiement de votre abonnement n'a pas réussi, veuillez réessayer",
          })
        }
      }
    },
    onIframeClosed({ url }) {
      console.log('iframe closedd', url, this.latestTransactionUrl)
      if (url !== this.latestTransactionUrl) return
      this.latestTransactionId = ''
      this.latestTransactionUrl = ''
      this.listenLaunchedTransaction = false
    },
  },
  watch: {
    subscription: {
      deep: true,
      immediate: true,
      handler(newVal) {
        if (!newVal.isActive) return
        this.$Events.dispatchEvent('toast_notification', {
          title: 'Vous êtes déjà passé pro',
          body: 'Profitez des avantages de Ekidiscount pro',
        })
        this.$router.push('/')
      },
    },
  },
  computed: {
    pricings() {
      return [
        {
          id: 'basic',
          title: 'Basic',
          amount: this.appInfo.plansPricesMonth?.basic || '...',
          description: 'Basic description',
          options: [
            { name: 'Ajout de produit illimité', isIncluded: true },
            { name: 'Gestion des commandes', isIncluded: true },
            {
              name: 'Paiement direct sur les médias sociaux',
              isIncluded: true,
            },
            { name: '10% de commission sur vente', isIncluded: true },
            { name: 'Processeur XOF', isIncluded: true },
            { name: 'Vente internationale (UEMOA)', isIncluded: true },
            { name: 'Reversement sur 10 jours', isIncluded: true },
          ],
        },
        {
          id: 'essenciel',
          title: 'Essentiel',
          amount: this.appInfo.plansPricesMonth?.essenciel || '...',
          description: 'Essentiel description',
          options: [
            { name: 'Ajout de produit illimité', isIncluded: true },
            { name: 'Gestion des commandes', isIncluded: true },
            {
              name: 'Paiement direct sur les médias sociaux',
              isIncluded: true,
            },
            { name: '10% de commission sur vente', isIncluded: true },
            { name: 'Processeurs XOF, NGN', isIncluded: true },
            { name: 'Vente internationale (UEMOA, Nigeria)', isIncluded: true },
            { name: 'Reversement sur 8 jours', isIncluded: true },
            { name: 'Règlement en XOF', isIncluded: true },
            { name: 'Nom de Domaine personnalisé', isIncluded: true },
          ],
        },
        {
          id: 'ekilite',
          title: 'Eki Lite',
          amount: this.appInfo.plansPricesMonth?.ekilite || '...',
          description: 'Eki Lite description',
          options: [
            { name: 'Ajout de produit illimité', isIncluded: true },
            { name: 'Gestion des commandes', isIncluded: true },
            { name: 'Carte VISA Eki', isIncluded: true },
            {
              name: 'Paiement direct sur les médias sociaux',
              isIncluded: true,
            },
            { name: '9% de commission sur vente', isIncluded: true },
            { name: 'Processeurs XOF, NGN, USD', isIncluded: true },
            { name: 'Vente internationale', isIncluded: true },
            { name: 'Reversement sur 6 jours', isIncluded: true },
            { name: 'Règlement en XOF', isIncluded: true },
            { name: 'Nom de Domaine personnalisé', isIncluded: true },
          ],
        },
        {
          id: 'ekipro',
          title: 'Eki Pro',
          amount: this.appInfo.plansPricesMonth?.ekipro || '...',
          description: 'Eki Pro description',
          options: [
            { name: 'Ajout de produit illimité', isIncluded: true },
            { name: 'Gestion des commandes', isIncluded: true },
            { name: 'Carte VISA Eki', isIncluded: true },
            {
              name: 'Paiement direct sur les médias sociaux',
              isIncluded: true,
            },
            { name: '8% de commission sur vente', isIncluded: true },
            { name: 'Processeurs XOF, NGN, USD, EUR', isIncluded: true },
            { name: 'Vente internationale', isIncluded: true },
            { name: 'Reversement sur 5 jours', isIncluded: true },
            { name: 'Règlement en XOF', isIncluded: true },
            { name: 'Nom de Domaine personnalisé', isIncluded: true },
          ],
        },
      ]
    },
    pricingOptions() {
      return {
        simple: [
          {
            name: 'Boutique personnalisée (design simple)',
            isIncluded: true,
          },
          {
            name: "Plusieurs produits autorisé (jusqu'à 50)",
            isIncluded: true,
          },
          {
            name: `Commission de ${this.appInfo?.merchandPaymentFeeMobileMoney} % par vente`,
            isIncluded: true,
          },
          {
            name: 'Support standard (email uniquement)',
            isIncluded: true,
          },
        ],
        pro: [
          {
            name: 'Boutique entièrement personnalisable (thèmes personnalisés)',
            isIncluded: true,
          },
          {
            name: 'Elargissement de la capacité à supporter plus de carte bancaire via CinetPay ou Stripe',
            isIncluded: true,
          },
          {
            name: 'Nombre de produits : illimité',
            isIncluded: true,
          },
          {
            name: `Commission de ${this.appInfo?.merchandPaymentFeeMobileMoneyPro} % par vente`,
            isIncluded: true,
          },
          {
            name: 'Outils marketing intégrés (Promotion, SEO)',
            isIncluded: true,
          },
          {
            name: 'Support 24/7 avec gestionnaire de compte dédié par chat',
            isIncluded: true,
          },
        ],
      }
    },
  },
}
</script>
